import { useIntl } from "react-intl";
import { Dialog } from "@/components/common/Dialog";
import { Button } from "@/components/design/Button";

// Exporting asks what goes out: the notebook with the assistant's answers, only the user's notes, or a final
// version the assistant writes first (it appears in the notebook and is exported from there).
export function StudioExportDialog({ open, finalDisabled, onClose, onWithAnswers, onNotesOnly, onFinal }: {
  open: boolean;
  finalDisabled: boolean;
  onClose: () => void;
  onWithAnswers: () => void;
  onNotesOnly: () => void;
  onFinal: () => void;
}) {
  const intl = useIntl();
  const option = (id: string, label: string, hint: string, onClick: () => void, disabled = false) => (
    <li className="flex flex-col gap-1">
      <Button id={id} variant="secondary" disabled={disabled} onClick={onClick}>{label}</Button>
      <p className="smycles-field-meta text-ink-muted">{hint}</p>
    </li>
  );
  return (
    <Dialog open={open} id="studio-export-dialog" onClose={onClose} dismiss="light" title={intl.formatMessage({ id: "studio.exportTitle", defaultMessage: "Export notebook" })}>
      <ul className="flex flex-col gap-4">
        {option(
          "studio-export-with-answers",
          intl.formatMessage({ id: "studio.exportWithAnswers", defaultMessage: "With the assistant's answers" }),
          intl.formatMessage({ id: "studio.exportWithAnswersHint", defaultMessage: "Your notes and the questions with their answers, in the notebook's order." }),
          onWithAnswers,
        )}
        {option(
          "studio-export-notes-only",
          intl.formatMessage({ id: "studio.exportNotesOnly", defaultMessage: "Only my notes" }),
          intl.formatMessage({ id: "studio.exportNotesOnlyHint", defaultMessage: "Just what you wrote, without the assistant." }),
          onNotesOnly,
        )}
        {option(
          "studio-export-final",
          intl.formatMessage({ id: "studio.exportFinal", defaultMessage: "Create a final version with the assistant" }),
          intl.formatMessage({ id: "studio.exportFinalHint", defaultMessage: "The assistant sums up your notes. The result appears in the notebook, where you export it." }),
          onFinal,
          finalDisabled,
        )}
      </ul>
    </Dialog>
  );
}
